import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Carlos', 'Ana', 'Laura', 'Pedro', 'Sofía', 'Diego', 'Valentina', 'Miguel', 'Lucía', 'Javier', 'Elena', 'Andrés', 'Camila'];
const CITIES = ['Bogotá, Colombia', 'Ciudad de México, México', 'Madrid, España', 'Buenos Aires, Argentina', 'Santiago, Chile', 'Lima, Perú', 'Barcelona, España', 'Medellín, Colombia', 'Guadalajara, México', 'Montevideo, Uruguay', 'Quito, Ecuador', 'Valencia, España'];
export const PurchaseNotification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      // Schedule next appearance (random between 8-15 seconds after hiding)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1)) + 8000 + 5000;
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-13">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0,
      y: 50
    }} animate={{
      x: 0,
      opacity: 1,
      y: 0
    }} exit={{
      x: 100,
      opacity: 0,
      y: 50
    }} className="fixed bottom-4 right-4 z-50 max-w-sm w-full md:w-auto" data-id="element-14">
          <div className="bg-white rounded-lg shadow-xl p-4 border-l-4 border-green-500 flex items-center gap-4" data-id="element-15">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-16">
              <CheckCircle className="w-6 h-6 text-green-600" data-id="element-17" />
            </div>
            <div data-id="element-18">
              <p className="text-sm font-medium text-gray-900" data-id="element-19">
                <span className="font-bold" data-id="element-20">{currentData.name}</span> de{' '}
                {currentData.city}
              </p>
              <p className="text-xs text-gray-500" data-id="element-21">
                acaba de comprar este libro digital
              </p>
              <p className="text-xs text-green-600 font-semibold mt-1" data-id="element-22">
                Hace unos instantes
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};